import React from 'react';
import AppCommon from '@nocode/common';

function App() {
  return <AppCommon />;
}

export default App;
